import Vue from 'vue'
import Router from 'vue-router'

import PcEntryRoutes from './pc-entry-routes'
import SpEntryRoutes from './sp-entry-routes'

Vue.use(Router)

let importComponentPath = function (componentPath) {
  let device = 'pc'
  if (location.href.indexOf('/sp') !== -1) {
    device = 'sp'
  }
  return import('@/components/' + device + '/' + componentPath)
}

let addSpOnlyClass = function (addClassName) {
  if (location.href.indexOf('/sp') !== -1) {
    return addClassName
  }
  return ''
}

var router = new Router({
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
  base: process.env.VIEW_BASE_URL,
  mode: 'history',
  routes: [
    {
      path: '/',
      component: () => importComponentPath('layout/layout.vue'),
      meta: { bodyClass: addSpOnlyClass('is-on') },
      children: [
        {
          path: '/',
          redirect: { name: 'form' }
        },
        {
          path: '/sp',
          redirect: { name: 'form_sp' }
        },
        { ...PcEntryRoutes },
        { ...SpEntryRoutes },
        {
          path: 'page-not-found',
          component: () => importComponentPath('error/404.vue'),
          name: '404',
          meta: {
            bodyClass: '',
            title: 'ページが見つかりません'
          }
        }
      ]
    },
    {
      path: '*',
      redirect: { name: '404' }
    }
  ]
})

export default router
